<div class="modal-header">
    Ajout de video Youtube
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="form-group">
        <label for="videoName">Nom de la vidéo</label>
        <input type="text"  [(ngModel)]="videoName"  class="form-control"  name="videoName" id="videoName" >
    </div>

    <div class="form-group">
        <label for="videoCode">
            Code youtube de la vidéo
        </label>
        <input type="text"  [(ngModel)]="videoCode"  class="form-control"  name="videoCode" id="videoCode" >
        <div class="sample">
            <span>Exemple : </span> https://www.youtube.com/watch?v=<strong class="text-primary">EhaYSd51ck0</strong>
        </div>
    </div>
    
  </div>
  <div class="modal-footer bg-light text-right">
    <button ngbAutoFocus type="button" class="btn btn-secondary me-1" (click)="activeModal.close()">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>&nbsp;
        {{ 'cancel.modal.label' | translate | titlecase }}
    </button>

    <button type="button" class="btn btn-primary" (click)="addVideo()">
        <fa-icon [icon]="['fas', 'save']"></fa-icon>&nbsp;
        {{ 'button.save.label' | translate | titlecase }}
    </button>
</div>
